import * as React from "react";
import Checkbox from "../../CheckboxNew";
import Input from "../../Input-new/Input";

const PropertyFinancials = ({isAgent, data, handleChangeInput, openFinancialsSpreadsheet, viewMode, deleted, isFinancing}) => {

    const parsePrecision = (value)=>{
        return Math.round(value*100)/100;
    }
    const getCalculatedData = () =>{
        const _units = data.units || 1;
        const _occupancy = data.vacancy || 100;
        if(data.net_operating_income && data.category=='apartments'){
            const rent = parseFloat(data.net_operating_income.replace(/,/g, ''));
            const result = (rent / (_units * (_occupancy/100)))
            return result ? parsePrecision(result) : result;
        }
        return data.rent_per_sqft ? parsePrecision(data.rent_per_sqft) : data.rent_per_sqft;
    }
    let price_per_unit = data.list_price != null && data.units != null ? parseFloat(data.list_price.replace(/,/g, '')) / (data.units != null && data.units > 0 ? data.units : 1) : '';
    if(price_per_unit){
        price_per_unit = parsePrecision(price_per_unit);
    }
    return (
        <div className="Property-financials">
            {
                !isFinancing &&
                <div className="Property-financials_actions">
                    <button type='button'
                            className="button-new positive"
                            onClick={openFinancialsSpreadsheet}
                    >
                        View Financials
                    </button>
                    <Checkbox
                        text="HIDE FINANCIALS"
                        type={viewMode ? "uncheckable" : "checkable"}
                        isSelected={data.hide_financials}
                        handleClick={handleChangeInput}
                        name="hide_financials"
                    />
                    {data.type === 'MT' &&
                        <Checkbox
                            text="PROFORMA"
                            type={viewMode ? "uncheckable" : "checkable"}
                            isSelected={data.is_proforma_pricing}
                            handleClick={handleChangeInput}
                            name="is_proforma_pricing"
                        />
                    }
                </div>
            }
            <div className="Property-financials_column">
                {
                    isFinancing ?
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="hsc_price"
                            label="Price"
                            value={data.hsc_price}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                        :
                        <Input
                            className="Property-financials_column_item"
                            type="text"
                            valueType="integer"
                            name="list_price"
                            label={"List Price"}
                            value={data.list_price}
                            disabled={isAgent}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="percent"
                    name={data.is_proforma_pricing ? "proforma_cap_rate" : "capitalization_rate"}
                    label={data.is_proforma_pricing ? "Proforma Cap Rate" : (data.category == 'apartments' ? "Cap Rate – auto" : "Cap Rate")}
                    value={ data.is_proforma_pricing ? data.proforma_cap_rate : data.capitalization_rate}
                    // Multi-Family cap rate comes from the View Financials popup (Pricing tab) on Submit.
                    disabled={isAgent || data.is_proforma_pricing || data.category == 'apartments'}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="integer"
                    name={data.is_proforma_pricing ? "proforma_noi" : "net_operating_income"}
                    label={data.is_proforma_pricing ? "Proforma NOI" : "NOI"}
                    value={data.is_proforma_pricing ? data.proforma_noi : data.net_operating_income}
                    disabled={isAgent || data.is_proforma_pricing}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                {
                    data.type === 'MT' &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="integer"
                        name={data.is_proforma_pricing ? "proforma_base_rent" : "base_rent"}
                        label={data.is_proforma_pricing ? "Proforma Base Rent" : "Base Rent"}
                        value={data.is_proforma_pricing ? data.proforma_base_rent : data.base_rent}
                        disabled={isAgent || data.is_proforma_pricing}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                }
                {data.category=='apartments' ?
                    <Input
                    className="Property-financials_column_item"
                    valueType="integer"
                    name="units"
                    label="# of UNITS"
                    value={data.units}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                : null }
            </div>
            <div className="Property-financials_column">
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="price_per_sqft"
                    label="PSF – auto"
                    value={data.price_per_sqft}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                {
                    (data.type === 'MT' || data.category == 'apartments')  &&
                    <Input
                        className="Property-financials_column_item"
                        type="text"
                        valueType="percent"
                        name="vacancy"
                        label={data.category == 'apartments' ? "Occupancy – auto" : "Occupancy"}
                        value={data.vacancy}
                        // Multi-Family occupancy is calculated by the View Financials popup (occupied / total units)
                        // and written here on Submit; editing it by hand would contradict the underwriting.
                        disabled={isAgent || data.category == 'apartments'}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                    />
                }
                <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="rent_per_sqft"
                    label={data.category=='apartments' ? "Rent/Unit – auto" : "Rent/Sq Ft – auto"}
                    value={getCalculatedData()}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                { data.category=='apartments' ?
                    <Input
                    className="Property-financials_column_item"
                    type="text"
                    valueType="float"
                    name="price_per_unit"
                    label="Price/Unit – auto"
                    value={price_per_unit}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                /> 
                : null    
                }          
            </div>
        </div>
    );
};

export default PropertyFinancials;
